import { call, take, fork } from "redux-saga/effects";

// https://redux-saga.js.org/docs/api/#takeleadingpattern-saga-args
// waits till finished before taking next pattern
export default function takeLeading(patternOrChannel, saga, ...args) {
    return fork(function* () {
        while (true) {
            const action = yield take(patternOrChannel);
            yield call(saga, ...args.concat(action));
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/takeLeading.js